import React, { useState } from "react"
import styled, { css } from "styled-components"
import WPLink from "components/shared/WPLink"
import { GatsbyImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretDown } from "@fortawesome/free-solid-svg-icons"

const MenuItemStyled = styled.li`
  padding: 0 .5rem;

  .link-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      width: 20px;
      height: 20px;
      position: relative;
    }

    a, span {
      font-family: ${props => props.theme.font.family.bold};
    }

    ${props => props.active && css`
      color: ${props => props.theme.colors.secondary} !important;
      a, span {
        color: ${props => props.theme.colors.secondary} !important;
      }
    `}
  }

  &:hover {
    .link-wrap {
      color: ${props => props.theme.colors.secondary};
      a, span {
        color: ${props => props.theme.colors.secondary};
      }
      svg {
        transform: rotate(180deg);
      }
    }
  }
  
`

const SubMenu =  styled.div`
  opacity: 0;
  visibility: hidden;
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  padding-top: 30px;
  background-color: ${props => props.theme.colors.white};
  justify-content: center;
  padding-bottom: 3rem;
  transition: all .3s ease;

  .sub-menu-content {
    max-width: 800px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    ul.sub-menu-ul {
      li {
        border: none;
        a {
          text-transform: none;
          padding: .5rem 1rem;
          color: ${props => props.theme.colors.primary};
        }
        span {
          text-transform: none;
          color: ${props => props.theme.colors.primary};
          font-family: ${props => props.theme.font.family.bold};
        }

        &.active {
          a, span {
            color: ${props => props.theme.colors.secondary};
          }
        }
      }
    }

    .title {
      color: ${props => props.theme.colors.secondary} !important;
      font-size: 1.1rem;
      cursor: default;
    }
  }
`

const ImageWrap = styled.div`
  aspect-ratio: 356/196;
  width: 356px;
`

export default function MenuItem({item, currentPath}) {
  const hasChildren = !!item.childItems.nodes && !!item.childItems.nodes.length

  const [hoverItem, setHoverItem] = useState(0)

  return(
    <MenuItemStyled active={currentPath === item.url}>
      <div className="link-wrap">
        {hasChildren ? (
          <span dangerouslySetInnerHTML={{ __html: item.label }} />
        ) : (
          <WPLink url={item.url} target={item.target}>
            <span dangerouslySetInnerHTML={{ __html: item.label }} />
          </WPLink>
        )}
        {hasChildren && (
          <FontAwesomeIcon icon={faCaretDown} />
        )}
      </div>

      {hasChildren && (
        <SubMenu className="sub-menu">
          <div className="sub-menu-content">
            <ul className="sub-menu-ul">
              <li>
                <span className="title">{item.label}</span>
              </li>
              {item.childItems.nodes.map((node, i) => {
                return(
                  <li 
                    className={`${currentPath === node.url ? "active" : ""}`} 
                    onMouseEnter={() => setHoverItem(i+1)} 
                    onMouseLeave={() => setHoverItem(0)}
                  >
                    <WPLink url={node.url} target={node.target}>
                      <span dangerouslySetInnerHTML={{ __html: node.label }} />
                    </WPLink>
                  </li>
                )
              })}
            </ul>
            <ImageWrap>
              {item.acfMenu.image && (
                <>
                  {hoverItem === 0 && (
                    <GatsbyImage image={item.acfMenu.image.localFile.childImageSharp.gatsbyImageData} alt={item.acfMenu.image.altText} />
                  )}
                </>
              )}
                  
              {item.childItems.nodes.map((node, i) => {
                if (node.acfMenu.image && hoverItem === i+1) {
                  return(
                    <GatsbyImage 
                      image={node.acfMenu.image.localFile.childImageSharp.gatsbyImageData} 
                      alt={node.acfMenu.image.altText} 
                    />
                  )
                }
              })}
            </ImageWrap>
          </div>
        </SubMenu>
      )}
    </MenuItemStyled>
  )
}